(() => {
    'use strict';

    const appendLoaderImage = (url, readyFn, errorFn, removeLoaderImage) => {
        const loaderImage = $('<img class="loader-image" alt="">');

        const startTime = Date.now();
        loaderImage.on('load', () => {
            const loadTimeMs = Date.now() - startTime;
            if (typeof readyFn === 'function') {
                requestAnimationFrame(() => {
                    loaderImage.removeClass('loader-image');
                    readyFn(url, loaderImage, loadTimeMs);
                });
            }
            if (removeLoaderImage) {
                loaderImage.remove();
            }
        });
        loaderImage.on('error', () => {
            loaderImage.remove();
            errorFn();
        });

        loaderImage.attr('src', url);
        real.dom.$body.append(loaderImage);

        return loaderImage;
    };

    real.image.load = (url, readyFn, removeLoaderImage = true) => {
        if (!url.startsWith('https://')) {
            url = real.baseUri + url;
        }

        let loaderImage;
        let waitingForManipulation = false;
        let manipulationCompleted = false;

        const load = () => {
            waitingForManipulation = false;
            manipulationCompleted = false;
            loaderImage = appendLoaderImage(url, (loadedUrl, image, loadTimeMs) => {
                if (image !== loaderImage) {
                    return;
                }
                real.events.off('uploadedfile:image:manipulated', manipulatedFn);
                if (typeof readyFn === 'function') {
                    readyFn(loadedUrl, image, loadTimeMs);
                }
            }, () => {
                waitingForManipulation = true;
                if (manipulationCompleted) {
                    load();
                }
            }, removeLoaderImage);
        };

        const manipulatedFn = (notification) => {
            if (notification.object.requested_url === url) {
                manipulationCompleted = true;
                if (waitingForManipulation) {
                    load();
                }
            }
        };

        // A manipulation can finish before the pending image response fires its error event.
        real.events.on('uploadedfile:image:manipulated', manipulatedFn);
        load();
    };
})();
